import { render, staticRenderFns } from "./diagnostics_h5.vue?vue&type=template&id=6604c1b2&scoped=true&"
import script from "./diagnostics_h5.vue?vue&type=script&lang=js&"
export * from "./diagnostics_h5.vue?vue&type=script&lang=js&"
import style0 from "./diagnostics_h5.vue?vue&type=style&index=0&id=6604c1b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6604c1b2",
  null
  
)

export default component.exports